import { MenuList as ChakraMenuList } from '@chakra-ui/react';

type MenuListProps = React.ComponentProps<typeof ChakraMenuList>;

const MenuList = ({ children, ...props }: Readonly<MenuListProps>) => {
  return <ChakraMenuList {...props}>{children}</ChakraMenuList>;
};

export default MenuList;
